import { useMemo } from "react";
import {
  PRESALE_CAMPAIGN,
  useCampaignCheckoutLinks,
} from "@/features/shared/presale";

import { type PresaleOffer, toPresaleOffers } from "../_libs/presale-offer";

/**
 * The campaign's founding offers, priced.
 *
 * `useCampaignCheckoutLinks` owns the request — shared with the resume lookup, so the two
 * cost one round trip between them — and `GET /checkout-links/list` already enriches each
 * line item with its `Product` and its Stripe price (`checkout-link-list.config.ts`), so
 * one request yields every offer AND its cart: no per-offer detail fetch, and no price
 * invented client-side.
 */
export function usePresaleOffers(): {
  offers: PresaleOffer[];
  isLoading: boolean;
  isError: boolean;
} {
  const { links, isLoading, isError } = useCampaignCheckoutLinks();
  const offers = useMemo(
    () => toPresaleOffers(links, PRESALE_CAMPAIGN),
    [links],
  );

  return { offers, isLoading, isError };
}
